import React from 'react';
import { TopFrameStyled, TopFrameNavCont, UserPanelBackground } from './TopFrameStyled';
import { Icon } from '../Icon';
import arrowDownBlack from '../../images/arrowDownBlack.svg';
import earth from '../../images/earth.svg';
import { UserPanel } from '../UserPanel';
/* Komponent górnego panelu nawigacji */
export var TopFrame = function (props) {
    var user = props.user, parent = props.parent, opened = props.opened, toggleOpen = props.toggleOpen, additionalInfo = props.additionalInfo;
    return (React.createElement(TopFrameStyled, null,
        React.createElement(TopFrameNavCont, null,
            React.createElement("div", { "data-cy": 'topFrameOpener', onClick: toggleOpen },
                parent ? (React.createElement(React.Fragment, null,
                    React.createElement("strong", null,
                        parent.firstName,
                        " ",
                        parent.lastName,
                        "\u00A0"),
                    React.createElement("span", { className: 'warning' },
                        props.translations.loggedAs,
                        "\u00A0"),
                    React.createElement("strong", { className: 'warning' },
                        user.firstName,
                        " ",
                        user.lastName))) : (React.createElement(React.Fragment, null,
                    React.createElement("strong", null,
                        user.firstName,
                        " ",
                        user.lastName,
                        "\u00A0"),
                    React.createElement("span", null, user.role))),
                React.createElement(Icon, { className: "icon" + (opened ? '__turned' : ''), path: arrowDownBlack }),
                React.createElement("strong", { className: 'warning additionalInfo' }, additionalInfo)),
            opened ? (React.createElement("div", null,
                React.createElement(Icon, { path: earth }),
                React.createElement("b", null, props.currentLanguage))) : null),
        React.createElement(UserPanel, { opened: opened, user: user, onClose: toggleOpen, onLogout: props.onLogout, translations: props.translations }, props.children),
        React.createElement(UserPanelBackground, { opened: opened, onClick: toggleOpen })));
};
